import {Formik} from "formik";
import {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {Button, Form, Modal} from "react-bootstrap";
import {IConfigTable} from "../../models/OctResponse";
import {CODE_SUCCESS, ERROR_MESSAGE} from "../../utils/Constant";
import CorrectiveSubsectionTable from "../components/CorrectiveSubsectionTable";
import {
  RESULT,
} from "../constants/CorrectiveSubsectionModal";
import EvaluateDetailsModal from "./EvaluateDetailsModal";
import {
  getLogAssessment,
  getSubSessionByPlanCriteria,
} from "../services/CorrectiveSubsectionServices";
import {toast} from "react-toastify";
import {AppContext} from "../../appContext/AppContext";
import {generateForm} from "../../utils/AppFunction";
import GenerateFormComponent from "../../component/generate-form/GenerateFormHTMLNoValid";
import ModalHeader from "../../component/ModalHeader";
import {useCSContext} from "../contexts";

type Props = {
  show: boolean;
  handleCloseDialog: () => void;
  type: string
  itemDetail: any;
  setItemDetail: Dispatch<SetStateAction<any>>;
};

const CorrectiveSubsectionModal = (props: Props) => {
  const {setIsLoading} = useContext(AppContext);
  const {isView} = useCSContext();
  const {show, handleCloseDialog, type, itemDetail, setItemDetail} = props;
  const [objectSearch, setObjectSearch] = useState<any>();
  const [configTable, setConfigTable] = useState<IConfigTable>({
    totalPages: 1,
    totalElements: 5,
    numberOfElements: 5,
  });
  const [dataTable, setDataTable] = useState<any>();
  const [dataTableDetailRow, setDataTableDetailRow] = useState<any>();
  const [showEvaluateDetailsModal, setShowEvaluateDetailsModal] = useState(false);
  const [tableCache, setTableCache] = useState<{ [key: string]: any[] }>({});
  const [reload, setReload] = useState(false);
  const [formJson, setFormJson] = useState<any>([]);

  useEffect(() => {
    updateForm().then(r => r);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateForm = async () => {
    if (type) {
      const data = await generateForm(type, setIsLoading);
      setFormJson(data || []);
    }
  };

  const handleSubmit = (values: any) => {
    const newValues = {
      planId: itemDetail?.planId,
      itemDetailId: itemDetail?.itemDetailId,
      planCriteriaId: itemDetail?.id,
      level: values?.level?.id,
    };
    setObjectSearch(newValues);
  }

  useEffect(() => {
    if (itemDetail) {
      const newCriteria = {
        ...itemDetail,
        chapterText: {
          name: `${itemDetail?.chapterCode}: ${itemDetail?.chapterName}`
        },
      };
      setItemDetail(newCriteria)
      setObjectSearch({
        planId: itemDetail?.planId,
        itemDetailId: itemDetail?.itemDetailId,
        planCriteriaId: itemDetail?.id,
        level: 1,
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (itemDetail) {
      setObjectSearch({
        planId: itemDetail?.planId,
        itemDetailId: itemDetail?.itemDetailId,
        planCriteriaId: itemDetail?.id,
        level: 1,
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetSubSessionByPlanCriteria = async (
    forceReload: boolean = false
  ): Promise<void> => {
    const key = objectSearch?.level;
    const cachedData = tableCache[key];

    if (!forceReload && cachedData) {
      setDataTable(cachedData);
      return;
    }

    const {planCriteriaId, ...rest} = objectSearch;
    setIsLoading(true);

    try {
      const {data} = await getSubSessionByPlanCriteria(rest);
      if (data?.code === CODE_SUCCESS) {
        const newData = data?.data?.map((item: any) => ({
          ...item,
          pointSelfAssessment:
            RESULT.find(
              (result: any) => result.id === item?.pointSelfAssessment
            ) || null,
          conclusionAssessment:
            RESULT.find(
              (result: any) => result.id === item?.conclusionAssessment
            ) || null,
          evidence: {
            id: item?.fileId,
            name: item?.fileName,
          },
        }));

        setDataTable(newData);

        setConfigTable({
          totalPages: data.data.totalPages,
          totalElements: data.data.totalElements,
          numberOfElements: data.data.numberOfElements,
        });

        setTableCache((prev) => ({
          ...prev,
          [key]: newData,
        }));
      }
    } catch (error) {
      console.error("error", error);
      toast.error(ERROR_MESSAGE);
    } finally {
      setIsLoading(false);
    }
  };

  // Khi objectSearch thay đổi (ví dụ: chuyển sang level khác), dùng cache nếu có
  useEffect(() => {
    if (objectSearch?.level) {
      handleGetSubSessionByPlanCriteria(false).then(r => r);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectSearch]);

  // Khi reload (ấn Save), luôn gọi lại API và ghi đè cache
  useEffect(() => {
    if (objectSearch?.level) {
      handleGetSubSessionByPlanCriteria(true).then(r => r);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const handleDoubleClick = async (data: any) => {
    if (!data?.id) {
      return toast.warning("Vui lòng đánh giá trước khi xem chi tiết");
    }

    const params = {assessmentId: data?.id};
    setIsLoading(true);
    try {
      const {data} = await getLogAssessment(params);
      if (data?.code === CODE_SUCCESS) {
        setDataTableDetailRow(data?.data);
        setShowEvaluateDetailsModal(true);
      }
    } catch (error) {
      console.error("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderSearchBtn = (props: { data: any }) => {
    const label = props.data?.dataComponent?.label || "";

    return (
      <div className="align-items-center d-flex h-100">
        <Button className="btn btn-fill min-w-120px spaces mx-3">
          {label || ""}
        </Button>
      </div>
    )
  }

  return (
    <Modal
      className="page-full"
      fullscreen
      dialogClassName="h-modal"
      size="xl"
      show={show}
      animation={false}
      centered
      backdropClassName="spaces top-50"
    >

      <Formik
        enableReinitialize
        initialValues={{[type]: {...itemDetail}}}
        onSubmit={handleSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <Form onSubmit={handleSubmit}>

            <ModalHeader onHide={handleCloseDialog} title="Danh sách tiểu mục khắc phục"/>
            <Modal.Body className="px-0 py-0 spaces overflow-hidden h-calc-vh-90 bg-white">
              <div className="spaces px-10">
                <GenerateFormComponent
                  isView={isView}
                  listFieldAuto={formJson}
                  handleChange={handleChange}
                  setValues={setValues}
                  values={values}
                  touched={touched}
                  errors={errors}
                  setFieldValue={setFieldValue}
                  modelID={type}
                  DynamicClass={"pl-38"}
                  customComponent={renderSearchBtn}
                />
              </div>

              <CorrectiveSubsectionTable
                dataTable={dataTable}
                setDataTable={setDataTable}
                objectSearch={objectSearch}
                setObjectSearch={setObjectSearch}
                configTable={configTable}
                setConfigTable={setConfigTable}
                handleDoubleClick={handleDoubleClick}
                type={type}
                tableCache={tableCache}
                setTableCache={setTableCache}
                reload={reload}
                setReload={setReload}
              />

              {showEvaluateDetailsModal && (
                <EvaluateDetailsModal
                  show={showEvaluateDetailsModal}
                  handleCloseDialog={() => setShowEvaluateDetailsModal(false)}
                  dataTableDetailRow={dataTableDetailRow}
                />
              )}
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default CorrectiveSubsectionModal;
